import React from 'react'

export type RadioButtonType = {
  label: string
  onClick: () => void
}

type RadioButtonGroupProps = {
  buttons: RadioButtonType[]
  activeIndex?: number
}

const RadioButton: React.FC<{
  isActive: boolean
  onClick: () => void
  children: React.ReactNode
}> = ({ isActive, onClick, children }) => (
  <button
    type="button"
    className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
      isActive
        ? 'bg-white text-black shadow-sm'
        : 'text-gray-700 hover:bg-gray-200'
    }`}
    onClick={onClick}
  >
    {children}
  </button>
)

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  buttons,
  activeIndex: externalActiveIndex,
}) => {
  const [internalActiveIndex, setInternalActiveIndex] = React.useState(0)

  // 外部から activeIndex が提供されている場合はそれを使用、そうでなければ内部状態を使用
  const activeIndex =
    externalActiveIndex !== undefined
      ? externalActiveIndex
      : internalActiveIndex

  return (
    <div className="bg-main-gray rounded-lg p-1 shadow-sm">
      <div className="flex">
        {buttons.map((button, index) => (
          <RadioButton
            key={`${button.label}-${index}`}
            isActive={activeIndex === index}
            onClick={() => {
              if (externalActiveIndex === undefined) {
                setInternalActiveIndex(index)
              }
              button.onClick()
            }}
          >
            {button.label}
          </RadioButton>
        ))}
      </div>
    </div>
  )
}

export default RadioButtonGroup
